import "./CollapseIcon.scss";

export const CollapseIcon = "collapseIcon";

const template = `
    {{ctrl.isOpen ? '-' : '+'}}
`;

export function collapseIcon() {
    return {
        template,
        bindings: {
            isOpen: "<"
        },
        controllerAs: "ctrl",
        controller: () => {}
    };
}
